import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo as getUserInfoFromCookie } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: getUserInfoFromCookie() || null,
    token: null
  },
  
  getters: {
    userInfo: state => state.userInfo,
    isLoggedIn: state => !!state.userInfo,
    userRole: state => state.userInfo?.role || '',
    userName: state => state.userInfo?.realName || '',
    isPurchaser: state => state.userInfo?.role === 'purchaser',
    isWarehouseKeeper: state => state.userInfo?.role === 'warehouse_keeper'
  },
  
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    
    SET_TOKEN(state, token) {
      state.token = token
    },
    
    CLEAR_USER_INFO(state) {
      state.userInfo = null
      state.token = null
    }
  },
  
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    
    clearUserInfo({ commit }) {
      commit('CLEAR_USER_INFO')
    }
  }
})



